import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RTPageLayout from '../common/RTPageLayout';
import Tile from '../common/Tile';
import RequireMenuAccess from '../common/RequireMenuAccess';
import '../common/rtCommon.css';
import '../common/Tile.css';

const tiles = [
  {
    icon: '👥',
    title: 'Manage Users',
    permissionKey: 'access-control.manage_users',
    description: 'View, activate, and reset passwords for PG and management login users',
    url: 'manage-users',
  },
  {
    icon: '🛡️',
    title: 'Role Settings',
    permissionKey: 'access-control.role_settings',
    description: 'Manage roles and per-menu read/write permissions',
    url: 'role-settings',
  },
];

const AccessControl = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <RequireMenuAccess>
      <RTPageLayout
        title="Access Control"
        mainSection
        activePath={location.pathname}
      >
        <div className="rt-tiles-grid">
          {tiles.map((tile, idx) => (
            <Tile
              key={idx}
              icon={tile.icon}
              title={tile.title}
              description={tile.description}
              permissionKey={tile.permissionKey}
              onClick={() => tile.url && navigate(tile.url)}
              tabIndex={0}
              role="button"
              onKeyPress={(e) => {
                if (e.key === 'Enter' && tile.url) navigate(tile.url);
              }}
            />
          ))}
        </div>
      </RTPageLayout>
    </RequireMenuAccess>
  );
};

export default AccessControl;
